export const MaintenanceAcceptanceRouting = {
  path: "/maintenanceAcceptance",
  name: "maintenanceAcceptance",
  meta: { title: "工程企业管理系统" },
  component: () =>
    import(/* webpackChunkName: "versionDetailH5" */ "@/views/join/h5/maintenance-acceptance/index.vue"),
  children: [],
};
